module.exports = __webpack_public_path__ + "static/wnetrze-3-pokojowe-mieszkanie-2-11a3292bee0a201f44e9e182c9d38946.jpg";